import { iChrItemResponse } from "../interfaces/chrInterfaces";
import { tAvailableFTokens, tAvailableUTokens, tDiscountPercent } from "../interfaces/interfaces";
import { discountPercents } from "../settings";
import { getTokenCurrencyByAddress } from "../utils/Chromia/utils";
import { cBigNumber } from "./BigNumber";

export class cChrItem {
	/**
	 * Item id.
	 */
	id: string;
	discountFt: tDiscountPercent;	// or BigNumber
	discountUt: tDiscountPercent;	// or BigNumber
	/**
	 * auto exercise
	 */
	eoptAeTime: number;
	/**
	 * Address.
	 */
	fToken: {
		address: string,
		currency: tAvailableFTokens,
	};
	ftMinDeposit: cBigNumber;
	utMinDeposit: cBigNumber;
	/**
	 * Address.
	 */
	owner: string;
	/**
	 * In seconds.
	 */
	periodStartTime: number;
	/**
	 * In seconds.
	 */
	periodTime: number;
	/**
	 * Address.
	 */
	pricePool: string;
	/**
	 * Address.
	 */
	uToken: {
		address: string,
		currency: tAvailableUTokens,
	};


	constructor (itemResponse: iChrItemResponse) {
		this.id = itemResponse.acc.toString('hex');
		// this.discountFt = new cBigNumber(itemResponse.discount_ft).mul(100, {raiseValue: true});
		// this.discountUt = new cBigNumber(itemResponse.discount_ut).mul(100, {raiseValue: true});

		const discountFt = +new cBigNumber(itemResponse.discount_ft).mul(100, {raiseValue: true}).valueStr;
		if (!discountPercents.includes(discountFt as any)) throw new Error();
		const discountUt = +new cBigNumber(itemResponse.discount_ut).mul(100, {raiseValue: true}).valueStr;
		if (!discountPercents.includes(discountUt as any)) throw new Error();

		this.discountFt = discountFt as tDiscountPercent;
		this.discountUt = discountUt as tDiscountPercent;
		this.eoptAeTime = itemResponse.eopt_ae_time;

		const ftAddress = itemResponse.ft.toString('hex');

		this.fToken = {
			address: ftAddress,
			currency: getTokenCurrencyByAddress('funding', ftAddress),
		};
		this.ftMinDeposit = new cBigNumber(itemResponse.min_depo_ft);
		this.utMinDeposit = new cBigNumber(itemResponse.min_depo_ut);
		this.owner = itemResponse.owner.toString('hex');
		this.periodStartTime = itemResponse.per_time;
		this.periodTime = itemResponse.per_time;
		this.pricePool = itemResponse.price_pool.toString('hex');

		const utAddress = itemResponse.ut.toString('hex');

		this.uToken = {
			address: utAddress,
			currency: getTokenCurrencyByAddress('underlying', utAddress),
		};
	}
}